import React from "react";
import { Controller } from "react-hook-form";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { FormHelperText, OutlinedInput, Typography } from "@mui/material";
import { StyledMenuItem } from "../StyledComponent";

const SelectWrapper = ({
  label,
  inputLabel,
  data = [],
  helperText,
  autoWidth,
  placeholder,
  control,
  name,
  defaultValue,
  width,
  disabled = false,
  validation,
  height,
  onBlur,
}) => {
  return (
    <Controller
      name={name || "name"}
      control={control}
      rules={validation}
      defaultValue={defaultValue}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <FormControl sx={{ width: width || "18.25vw", borderRadius: "5px" }} size="small" disabled={disabled} error={!!error}>
          <Select
            displayEmpty
            value={value || defaultValue || ""}
            // onBlur={onBlur}
            onChange={(e) => {
              onChange(e);
              onBlur?.(e);
            }}
            autoWidth={autoWidth}
            name={name}
            sx={{ width: width || "18.25vw", borderRadius: "1px" }}
            // size="small"
            // variant="outlined"
            input={<OutlinedInput style={{ borderRadius: "1px", height: height || "30px", width: width || "18.25vw" }} />}
            renderValue={(selected) => {
              if (selected.length === 0) {
                return <em style={{ fontStyle: "normal" }}>{placeholder}</em>;
              }
              return selected;
            }}
            MenuProps={{
              disablePortal: false,
              disableScrollLock: true,
            }}
            inputProps={{ "aria-label": "Without label" }}
          >
            <StyledMenuItem disabled value="">
              <em style={{ fontStyle: "normal" }}>{placeholder}</em>
            </StyledMenuItem>
            {Array.isArray(data) &&
              data?.map((item) => {
                const dropdowns = item?.name || item?.value || item?.i18nKey;
                return (
                  <StyledMenuItem value={dropdowns} key={dropdowns}>
                    {dropdowns}
                  </StyledMenuItem>
                );
              })}
          </Select>
          {error && (
            <Typography variant="caption" className="error-message">
              {error.message}
            </Typography>
          )}
          {helperText && !error && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
      )}
    />
  );
};

export default SelectWrapper;
